import { useState } from "react";
import { updateUserInfo } from "../services/userService";
import { useAuth } from "../contexts/authProvider";
import Icon from "./AppIcon";
import { useModal } from "hooks/useModal";

const GENDER_OPTIONS = [
  { value: "masculino", label: "Masculino" },
  { value: "feminino", label: "Feminino" },
  { value: "homem_trans", label: "Homem trans" },
  { value: "mulher_trans", label: "Mulher trans" },
  { value: "nao_binario", label: "Não-binário" },
  { value: "genero_fluido", label: "Gênero fluido" },
  { value: "agender", label: "Agênero" },
  { value: "intersexo", label: "Intersexo" },
  { value: "outro", label: "Outro" },
  { value: "prefiro_nao_informar", label: "Prefiro não informar" },
];

const GenderRequiredModal = () => {
  useModal(true, () => {}, { closeOnEscape: false, closeOnBack: false });

  const { setGenderDefined } = useAuth();
  const [selected, setSelected] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleConfirm = async () => {
    if (!selected) return;
    setLoading(true);
    setError(null);
    try {
      await updateUserInfo({ gender: selected });
      setGenderDefined(selected);
    } catch {
      setError("Erro ao salvar. Tente novamente.");
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm">
      <div className="bg-card rounded-2xl shadow-2xl w-full max-w-sm overflow-hidden">
        {/* Header */}
        <div className="p-6 pb-4 text-center">
          <div className="w-14 h-14 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
            <Icon name="User" size={28} className="text-primary" />
          </div>
          <h2 className="text-xl font-bold text-foreground mb-2">
            Uma última coisa!
          </h2>
          <p className="text-sm text-muted-foreground">
            Para melhorar suas recomendações de match, precisa&shy;mos saber seu
            gênero. Esta informação é usada apenas para otimizar conexões.
          </p>
        </div>

        {/* Options */}
        <div className="px-6 pb-4 grid grid-cols-2 gap-2">
          {GENDER_OPTIONS.map((opt) => (
            <label
              key={opt.value}
              className={`flex items-center justify-center px-3 py-3 rounded-xl border cursor-pointer text-sm font-medium transition-all ${
                selected === opt.value
                  ? "border-primary bg-primary/10 text-primary ring-2 ring-primary/30"
                  : "border-border bg-background text-muted-foreground hover:border-primary/50"
              }`}
            >
              <input
                type="radio"
                name="gender-required"
                value={opt.value}
                checked={selected === opt.value}
                onChange={() => setSelected(opt.value)}
                className="sr-only"
              />
              {opt.label}
            </label>
          ))}
        </div>

        {/* Error */}
        {error && (
          <div className="mx-6 mb-3 flex items-center space-x-2 p-3 bg-destructive/10 border border-destructive/20 rounded-lg">
            <Icon
              name="AlertCircle"
              size={16}
              className="text-destructive flex-shrink-0"
            />
            <p className="text-xs text-destructive">{error}</p>
          </div>
        )}

        {/* Action */}
        <div className="px-6 pb-6">
          <button
            onClick={handleConfirm}
            disabled={!selected || loading}
            className="w-full px-4 py-3 bg-primary text-primary-foreground rounded-xl font-semibold transition-all hover:bg-primary/90 disabled:opacity-40 disabled:cursor-not-allowed flex items-center justify-center gap-2"
          >
            {loading ? (
              <>
                <Icon name="Loader2" size={18} className="animate-spin" />
                Salvando...
              </>
            ) : (
              "Confirmar"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default GenderRequiredModal;
